export class TwoFactorAuthData {
  code = '';
}
